<template>
  <div
    :class="[
      'loading-anim',
      `loading-anim--${initialLoad ? view : 'media'}`,
      { 'loading-anim__initial': initialLoad },
    ]"
  ></div>
</template>

<script>
export default {
  props: {
    initialLoad: {
      type: Boolean,
      default: false,
    },
    view: {
      type: String,
      default: 'banner',
    },
  },
};
</script>

<style lang="scss" scoped>
.loading-anim {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  background-color: $black;

  &::after {
    @include pseudo;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 6rem;
    height: 6rem;
    margin: auto;
    border: 0.25rem solid rgba($blue, 0.6);
    border-top-color: $blue;
    border-radius: 50%;
    animation: loading-spin 1s infinite linear;
  }

  &__initial {
    height: 600px;
    aspect-ratio: unset;

    @include media-up($phone-large) {
      height: 354px;
    }

    @include media-up($tablet) {
      height: 430px;
    }

    &::after {
      border: 0.5rem solid rgba($grey-alt-2, 0.5);
      border-top-color: $blue;
      opacity: 0.8;
    }
  }

  &--banner {
    background-color: unset;

    .stacked-view & {
      @include media-only($phone-large, $desktop) {
        height: 660px;
      }
    }
  }

  &--landing {
    height: 100vh;
    aspect-ratio: unset;
    background-color: unset;
  }
}
</style>
